import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, ViewChild, Output, NgModule } from '@angular/core';
import { pluck, map, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import moment from 'moment';
import * as i2 from 'custom-button-action';
import * as i3 from 'primeng/card';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/table';
import * as i6 from 'primeng/api';
import * as i7 from 'primeng/overlaypanel';
import * as i8 from 'primeng/button';
import * as i9 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i10 from 'primeng/inputtext';
import * as i11 from 'primeng/dropdown';
import * as i12 from 'primeng/calendar';
import * as i13 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i14 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import { PrimengLibraryModule } from 'primeng-library';
import { MatBadgeModule } from '@angular/material/badge';

class FdMasterTableListCardService {
    constructor(http) {
        this.http = http;
    }
    getCustomHeaders(pageBuilderId) {
        return this.http.get(`/vd/formBuilder/fetch/customHeaders/${pageBuilderId}`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getBeneCustomHeaders(pageBuilderId) {
        return this.http.get(`/vd/formBuilder/pageForm/${pageBuilderId}/masterList`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getMasterListData(pageFormId, companyId, payload) {
        return this.http.post(`/vd/formBuilder/company/${companyId}/pageForm/${pageFormId}/formsData`, payload).pipe(pluck('data'), map((data) => {
            return data;
        }));
    } // 
    getBeneProfileMasterListData(moduleId, pageFormId, companyId, payload) {
        return this.http
            .post(`/vd/formBuilder/module/${moduleId}/pageForm/${pageFormId}/company/${companyId}/masterList/list`, payload)
            .pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
}
FdMasterTableListCardService.ɵfac = function FdMasterTableListCardService_Factory(t) { return new (t || FdMasterTableListCardService)(i0.ɵɵinject(i1.HttpClient)); };
FdMasterTableListCardService.ɵprov = i0.ɵɵdefineInjectable({ token: FdMasterTableListCardService, factory: FdMasterTableListCardService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FdMasterTableListCardService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["filterPanel"];
function FdMasterTableListCardComponent_div_6_ng_template_3_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "input", 28);
    i0.ɵɵlistener("ngModelChange", function FdMasterTableListCardComponent_div_6_ng_template_3_div_2_div_5_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r15); const filter_r8 = i0.ɵɵnextContext().$implicit; return filter_r8.value = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", filter_r8.value);
} }
function FdMasterTableListCardComponent_div_6_ng_template_3_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "input", 29);
    i0.ɵɵlistener("ngModelChange", function FdMasterTableListCardComponent_div_6_ng_template_3_div_2_div_6_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r19); const filter_r8 = i0.ɵɵnextContext().$implicit; return filter_r8.value = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", filter_r8.value);
} }
function FdMasterTableListCardComponent_div_6_ng_template_3_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p-dropdown", 30);
    i0.ɵɵlistener("ngModelChange", function FdMasterTableListCardComponent_div_6_ng_template_3_div_2_div_7_Template_p_dropdown_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r23); const filter_r8 = i0.ɵɵnextContext().$implicit; return filter_r8.value = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("options", filter_r8.options)("ngModel", filter_r8.value);
} }
function FdMasterTableListCardComponent_div_6_ng_template_3_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p-calendar", 31);
    i0.ɵɵlistener("ngModelChange", function FdMasterTableListCardComponent_div_6_ng_template_3_div_2_div_8_Template_p_calendar_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r27); const filter_r8 = i0.ɵɵnextContext().$implicit; return filter_r8.value = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", filter_r8.value)("showIcon", true);
} }
function FdMasterTableListCardComponent_div_6_ng_template_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵelementStart(2, "label", 25);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 26);
    i0.ɵɵtemplate(5, FdMasterTableListCardComponent_div_6_ng_template_3_div_2_div_5_Template, 2, 1, "div", 27);
    i0.ɵɵtemplate(6, FdMasterTableListCardComponent_div_6_ng_template_3_div_2_div_6_Template, 2, 1, "div", 27);
    i0.ɵɵtemplate(7, FdMasterTableListCardComponent_div_6_ng_template_3_div_2_div_7_Template, 2, 2, "div", 27);
    i0.ɵɵtemplate(8, FdMasterTableListCardComponent_div_6_ng_template_3_div_2_div_8_Template, 2, 2, "div", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r8 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(filter_r8.displayName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", filter_r8.filterUITypeId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "TEXTBOX");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "NUMBER");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "DROPDOWN");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "CALENDAR");
} }
function FdMasterTableListCardComponent_div_6_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵtemplate(2, FdMasterTableListCardComponent_div_6_ng_template_3_div_2_Template, 9, 6, "div", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 18);
    i0.ɵɵelementStart(4, "div", 20);
    i0.ɵɵelementStart(5, "button", 21);
    i0.ɵɵlistener("click", function FdMasterTableListCardComponent_div_6_ng_template_3_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(2); return ctx_r29.onFilter(); });
    i0.ɵɵtext(6, "Submit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 22);
    i0.ɵɵlistener("click", function FdMasterTableListCardComponent_div_6_ng_template_3_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(2); return ctx_r31.onClear(); });
    i0.ɵɵtext(8, "Clear");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r6.filters);
} }
const _c1 = function () { return { width: "400px", padding: "0px 10px" }; };
function FdMasterTableListCardComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "p-overlayPanel", 13, 14);
    i0.ɵɵtemplate(3, FdMasterTableListCardComponent_div_6_ng_template_3_Template, 9, 1, "ng-template", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 16);
    i0.ɵɵlistener("click", function FdMasterTableListCardComponent_div_6_Template_button_click_4_listener($event) { i0.ɵɵrestoreView(_r33); const _r5 = i0.ɵɵreference(2); return _r5.toggle($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(3, _c1));
    i0.ɵɵproperty("dismissable", false);
} }
function FdMasterTableListCardComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "button", 32);
    i0.ɵɵelement(2, "i", 33);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r34 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", button_r34 == null ? null : button_r34.name, " ");
} }
function FdMasterTableListCardComponent_ng_template_12_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r38 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", col_r38.displayName, " ");
} }
function FdMasterTableListCardComponent_ng_template_12_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 37);
    i0.ɵɵtext(1, "Action");
    i0.ɵɵelementEnd();
} }
function FdMasterTableListCardComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, FdMasterTableListCardComponent_ng_template_12_th_1_Template, 2, 1, "th", 34);
    i0.ɵɵtemplate(2, FdMasterTableListCardComponent_ng_template_12_th_2_Template, 2, 0, "th", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r35 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", columns_r35);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.actionsInfo == null ? null : ctx_r2.actionsInfo.actions == null ? null : ctx_r2.actionsInfo.actions.redirect);
} }
function FdMasterTableListCardComponent_ng_template_13_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r43 = ctx.$implicit;
    const rowData_r39 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", rowData_r39[col_r43.displayName], " ");
} }
function FdMasterTableListCardComponent_ng_template_13_td_2_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 44);
    i0.ɵɵlistener("click", function FdMasterTableListCardComponent_ng_template_13_td_2_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r50); const rowData_r39 = i0.ɵɵnextContext(2).$implicit; const ctx_r48 = i0.ɵɵnextContext(); return ctx_r48.handleEdit(rowData_r39); });
    i0.ɵɵtext(1, " Edit");
    i0.ɵɵelementEnd();
} }
function FdMasterTableListCardComponent_ng_template_13_td_2_ng_template_9_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 44);
    i0.ɵɵlistener("click", function FdMasterTableListCardComponent_ng_template_13_td_2_ng_template_9_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r55); const item_r52 = ctx.$implicit; const rowData_r39 = i0.ɵɵnextContext(3).$implicit; const ctx_r53 = i0.ɵɵnextContext(); return ctx_r53.handleRedirect(item_r52, rowData_r39); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r52 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r52.displayName, "");
} }
function FdMasterTableListCardComponent_ng_template_13_td_2_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FdMasterTableListCardComponent_ng_template_13_td_2_ng_template_9_button_0_Template, 2, 1, "button", 45);
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngForOf", ctx_r47.redirectList);
} }
function FdMasterTableListCardComponent_ng_template_13_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 39);
    i0.ɵɵelementStart(1, "mat-icon", 40);
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "settings");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-icon");
    i0.ɵɵtext(5, "keyboard_arrow_down");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "mat-menu", null, 41);
    i0.ɵɵtemplate(8, FdMasterTableListCardComponent_ng_template_13_td_2_button_8_Template, 2, 0, "button", 42);
    i0.ɵɵtemplate(9, FdMasterTableListCardComponent_ng_template_13_td_2_ng_template_9_Template, 1, 1, "ng-template", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r45 = i0.ɵɵreference(7);
    const ctx_r42 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matMenuTriggerFor", _r45);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", ctx_r42.actionsInfo == null ? null : ctx_r42.actionsInfo.actions == null ? null : ctx_r42.actionsInfo.actions.edit);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r42.actionsInfo == null ? null : ctx_r42.actionsInfo.actions == null ? null : ctx_r42.actionsInfo.actions.redirect);
} }
function FdMasterTableListCardComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, FdMasterTableListCardComponent_ng_template_13_td_1_Template, 2, 1, "td", 7);
    i0.ɵɵtemplate(2, FdMasterTableListCardComponent_ng_template_13_td_2_Template, 10, 3, "td", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r40 = ctx.columns;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", columns_r40);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.actionsInfo == null ? null : ctx_r3.actionsInfo.actions == null ? null : ctx_r3.actionsInfo.actions.redirect);
} }
function FdMasterTableListCardComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 46);
    i0.ɵɵtext(2, "No data available.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("colspan", ctx_r4.inputParams.properties.selectedColumns.length);
} }
const _c2 = function (a0) { return { width: a0 }; };
const _c3 = function (a0) { return { "fb-rgt-br": a0 }; };
//import { combineLatest ,pipe,take} from 'rxjs/operators';
class FdMasterTableListCardComponent {
    constructor(fdMasterTableListCardService, customButtonActionService
    //private cdr: ChangeDetectorRef
    ) {
        this.fdMasterTableListCardService = fdMasterTableListCardService;
        this.customButtonActionService = customButtonActionService;
        this.tableValue = [];
        this.filters = [];
        this.redirectList = [];
        this.actionTriggered = new EventEmitter();
    }
    ngOnInit() {
        // console.log("changes",changes);
        this.allTableValue = [];
        if (this.inputParams) {
            this.companyId = 'companyId' in sessionStorage ? parseInt(sessionStorage.getItem('companyId')) : null;
            this.formBuilderId = this.inputParams.selectedMasterTable ? this.inputParams.selectedMasterTable : null;
            this.filters = this.inputParams.properties && this.inputParams.properties.selectedFilter && this.inputParams.properties.selectedFilter.length > 0 ? this.inputParams.properties.selectedFilter : [];
            if (this.formBuilderId && this.inputParams.properties) {
                this.inputParams.properties.selectedColumns.map(x => {
                    return Object.assign({}, x);
                });
                if (this.inputParams.properties.isBeneProfileMasterData && this.formBuilderInfo && this.formBuilderInfo.moduleId) {
                    this.getMasterListTableDataForBeneficiaryProfile();
                }
                else {
                    this.getMasterListTableData();
                }
            }
        }
        // this.cdr.detectChanges();
    }
    // clearToDateFilter(filter) {
    // }
    // clearFilters(event, element) {
    //   //closeTimeselector() {
    //   element.hide(event);
    //   // console.log("closer called");
    //   //}
    // }
    // applyFilters() {
    //   // console.log("this.inputParams", this.inputParams)
    //   // console.log("filter", this.filters);
    // }
    getMasterListTableDataForBeneficiaryProfile() {
        const payload = {
            "pageNumber": 0,
            "recordsPerPage": 0
        };
        this.fdMasterTableListCardService.getBeneProfileMasterListData(this.formBuilderInfo.moduleId, this.formBuilderId, this.companyId, payload).pipe(take(1))
            .subscribe((response) => {
            var _a;
            if (response === null || response === void 0 ? void 0 : response.actionsJson) {
                const actionsData = JSON.parse(response.actionsJson);
                if (actionsData.redirectActions && actionsData.redirectActions.length > 0) {
                    this.redirectList = actionsData.redirectActions;
                    this.actionsInfo = actionsData;
                }
            }
            if (((_a = response === null || response === void 0 ? void 0 : response.elements) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                this.isBeneficiaryProfileListing = true;
                try {
                    this.allTableValue = response.elements.map(x => {
                        let returnObj = {};
                        Object.keys(x).forEach((key) => {
                            if (!isNaN(key.trim())) {
                                const columneObj = this.inputParams.properties.selectedColumns.find(y => y.rptGroupPlaceHolderId === Number(key.trim()));
                                returnObj[columneObj.displayName] = x[key];
                            }
                            if (key.trim() === 'id') {
                                returnObj[`fb_id`] = x[key];
                            }
                            if (key.trim() === 'beneficiaryId') {
                                returnObj[`fb_beneficiaryId`] = x[key];
                            }
                            if (key.trim() === 'employeeId') {
                                returnObj[`fb_employeeId`] = x[key];
                            }
                            if (key.trim() === 'formDataId') {
                                returnObj['formDataId'] = x[key];
                            }
                            if (key.trim() === 'pageFormId') {
                                returnObj['pageFormId'] = x[key];
                            }
                            if (key.trim() === 'id') {
                                returnObj['leaveRequestId'] = x[key];
                            }
                        });
                        return Object.assign({}, returnObj);
                    });
                }
                catch (error) {
                    // console.log("bene data error", error);
                }
            }
            else {
                this.allTableValue = [];
            }
            // console.log("bene data list", this.allTableValue);
            this.fillFilterValues();
        });
    }
    getMasterListTableData() {
        const payload = {
            "pageNumber": 0,
            "recordsPerPage": 0
        };
        this.fdMasterTableListCardService.getMasterListData(this.formBuilderId, this.companyId, payload).pipe(take(1))
            .subscribe((response) => {
            var _a;
            // console.log("response", response);
            this.allTableValue = ((_a = response === null || response === void 0 ? void 0 : response.createdForms) === null || _a === void 0 ? void 0 : _a.length) > 0 ? JSON.parse(JSON.stringify(response.createdForms)) : [];
            this.fillFilterValues();
        });
    }
    fillFilterValues() {
        var _a, _b;
        if (((_a = this.allTableValue) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = this.filters) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            this.filters = this.filters
                .map(filter => {
                switch (filter.filterUITypeId) {
                    case 'DROPDOWN':
                        return Object.assign(Object.assign({}, filter), { options: Array.from(new Set(this.allTableValue.map(x => x[filter.displayName]))) });
                    default:
                        return Object.assign({}, filter);
                }
            });
            this.onFilter();
        }
        else {
            this.tableValue = JSON.parse(JSON.stringify(this.allTableValue));
            // console.log("$$$ this.tableValue", this.tableValue);
        }
    }
    onFilter() {
        if (this.filters.some(filter => filter.value)) {
            this.tableValue = this.allTableValue.filter(item => this.meetsFilterCriteria(item));
        }
        else {
            this.tableValue = JSON.parse(JSON.stringify(this.allTableValue));
        }
        if (this.overlayPanel) {
            this.overlayPanel.hide();
        }
    }
    meetsFilterCriteria(item) {
        for (const filter of this.filters.filter(filter => filter.value)) {
            if (filter.filterUITypeId === "CALENDAR") {
                filter.value = moment(filter.value).format("YYYY-MM-DD");
            }
            const value = item[filter.displayName];
            if (['TEXTBOX', 'NUMBER', 'DROPDOWN', 'CALENDAR'].includes(filter.filterUITypeId) &&
                !(value.toLowerCase().includes(filter.value.toLowerCase()) || filter.value.toLowerCase().includes(value.toLowerCase()))) {
                return false;
            }
        }
        return true;
    }
    handleEdit(rowData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if ('fbFormDataDTO' in sessionStorage) {
            sessionStorage.removeItem('fbFormDataDTO');
        }
        sessionStorage.setItem('pageFormId', rowData.pageFormId || null);
        sessionStorage.setItem('formDataId', rowData.formDataId || null);
        this.actionTriggered.emit({
            id: this.isBeneficiaryProfileListing ?
                (((_b = (_a = this.actionsInfo) === null || _a === void 0 ? void 0 : _a.editJsonAction) === null || _b === void 0 ? void 0 : _b.selectedEditOption) &&
                    ((_d = (_c = this.actionsInfo) === null || _c === void 0 ? void 0 : _c.editJsonAction) === null || _d === void 0 ? void 0 : _d.selectedEditOption) === 'BF' ?
                    rowData.formDataId : rowData.fb_id) :
                rowData.id,
            isBeneficiaryProfileListing: this.isBeneficiaryProfileListing,
            beneficiaryId: rowData.fb_beneficiaryId && this.isBeneficiaryProfileListing ? rowData.fb_beneficiaryId : null,
            redirectTo: ((_f = (_e = this.actionsInfo) === null || _e === void 0 ? void 0 : _e.editJsonAction) === null || _f === void 0 ? void 0 : _f.selectedEditOption) && ((_h = (_g = this.actionsInfo) === null || _g === void 0 ? void 0 : _g.editJsonAction) === null || _h === void 0 ? void 0 : _h.selectedEditOption) === 'BF' ? (_k = (_j = this.actionsInfo) === null || _j === void 0 ? void 0 : _j.editJsonAction) === null || _k === void 0 ? void 0 : _k.selectedButtonPageFormId : 0
        });
    }
    setOrRemoveSessionStorageItem(key, value) {
        if (value !== null && value !== undefined) {
            sessionStorage.setItem(key, value);
        }
        else if (sessionStorage.getItem(key)) {
            sessionStorage.removeItem(key);
        }
    }
    handleRedirect(redirectItem, rowData) {
        if ('fbFormDataDTO' in sessionStorage) {
            const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO'));
            fbFormDataDTO.push(rowData.apiRowData);
            sessionStorage.setItem('fbFormDataDTO', JSON.stringify(fbFormDataDTO));
        }
        else {
            sessionStorage.setItem('fbFormDataDTO', JSON.stringify([rowData.apiRowData]));
        }
        if (redirectItem.pageFormId) {
            this.customButtonActionService.getPageFormById(redirectItem.pageFormId)
                .pipe(take(1))
                .subscribe((response) => {
                if (response) {
                    const item = {
                        formType: response.buildFormatTypeId,
                        pageFormId: response.id
                    };
                    // if (this.isBeneficiaryProfileListing) {
                    // this.setOrRemoveSessionStorageItem('FbEmployeeId', rowData.fb_beneficiaryId);
                    this.setOrRemoveSessionStorageItem('FbActualEmployeeId', rowData.fb_employeeId);
                    this.setOrRemoveSessionStorageItem('AttendanceDataId', rowData.fb_id);
                    this.setOrRemoveSessionStorageItem('idToGetDetails', rowData.fb_id);
                    if (rowData.leaveRequestId) {
                        this.setOrRemoveSessionStorageItem('leaveRequestId', rowData.leaveRequestId);
                    }
                    // } else {
                    // this.setOrRemoveSessionStorageItem('formDataId', rowData.id);
                    //  }
                    this.customButtonActionService.onLinkRedirectPageSubject.next(item);
                }
            });
        }
    }
    onClear() {
        this.filters = this.filters
            .map(x => {
            return Object.assign(Object.assign({}, x), { value: null });
        });
        this.onFilter();
    }
}
FdMasterTableListCardComponent.ɵfac = function FdMasterTableListCardComponent_Factory(t) { return new (t || FdMasterTableListCardComponent)(i0.ɵɵdirectiveInject(FdMasterTableListCardService), i0.ɵɵdirectiveInject(i2.CustomButtonActionService)); };
FdMasterTableListCardComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FdMasterTableListCardComponent, selectors: [["lib-fd-master-table-list-card"]], viewQuery: function FdMasterTableListCardComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.overlayPanel = _t.first);
    } }, inputs: { inputParams: "inputParams", formBuilderInfo: "formBuilderInfo" }, outputs: { actionTriggered: "actionTriggered" }, decls: 15, vars: 12, consts: [["styleClass", "fd-master-table-card"], [1, "fd-mar-btm"], [1, "fd-title-container"], [1, "left-box"], [1, "master-table-head", 3, "ngClass"], ["class", "filter position-relative", 4, "ngIf"], [1, "right-box"], [4, "ngFor", "ngForOf"], ["styleClass", "p-datatable-fb-forms", 3, "value", "columns"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], [1, "filter", "position-relative"], ["styleClass", "overlayPanel", 3, "dismissable"], ["filterPanel", ""], ["pTemplate", ""], ["type", "text", "pButton", "", "label", "Filter", "icon", "pi pi-filter", "iconPos", "right", 1, "fd-taskFilter-btn", "mt-2", "ml-2", 3, "click"], [1, "fb-filter-container"], [1, "row"], ["class", "col-6", 4, "ngFor", "ngForOf"], [1, "col-12"], ["type", "submit", 1, "btn", "btn-primary", "mr-3", 3, "click"], ["type", "button", 1, "btn", "btn-light", 3, "click"], [1, "col-6"], [1, "form-group"], ["for", "exampleInputEmail1"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["type", "text", "pInputText", "", "placeholder", "Enter", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "number", "pInputText", "", "placeholder", "Enter", 1, "form-control", 3, "ngModel", "ngModelChange"], ["placeholder", "Select", 1, "form-control", 3, "options", "ngModel", "ngModelChange"], ["yearRange", "1900:2100", "monthNavigator", "true", "yearNavigator", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "YYYY-MM-DD", 1, "im-input-calendar", "mw-100", "datePicker-emp", 3, "ngModel", "showIcon", "ngModelChange"], ["type", "button", 1, "btn", "btn-primary"], [1, "fa", "fa-plus-circle"], ["scope", "col", 4, "ngFor", "ngForOf"], ["scope", "col", "class", "action-col-width", 4, "ngIf"], ["scope", "col"], ["scope", "col", 1, "action-col-width"], ["class", "action-col-width", 4, "ngIf"], [1, "action-col-width"], [1, "mr-1", "icn", "settingsBorder", 3, "matMenuTriggerFor"], ["menu", "matMenu"], ["mat-menu-item", "", 3, "click", 4, "ngIf"], [3, "ngIf"], ["mat-menu-item", "", 3, "click"], ["mat-menu-item", "", 3, "click", 4, "ngFor", "ngForOf"], [1, "text-center"]], template: function FdMasterTableListCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p-card", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, FdMasterTableListCardComponent_div_6_Template, 5, 4, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵtemplate(8, FdMasterTableListCardComponent_div_8_Template, 4, 1, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(9, "hr");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div");
        i0.ɵɵelementStart(11, "p-table", 8);
        i0.ɵɵtemplate(12, FdMasterTableListCardComponent_ng_template_12_Template, 3, 2, "ng-template", 9);
        i0.ɵɵtemplate(13, FdMasterTableListCardComponent_ng_template_13_Template, 3, 2, "ng-template", 10);
        i0.ɵɵtemplate(14, FdMasterTableListCardComponent_ng_template_14_Template, 3, 1, "ng-template", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(8, _c2, ctx.inputParams.style.width));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c3, ctx.filters.length > 0));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.inputParams == null ? null : ctx.inputParams.label, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.filters.length > 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.inputParams.properties.selectedButtonForms);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("value", ctx.tableValue)("columns", ctx.inputParams.properties.selectedColumns);
    } }, directives: [i3.Card, i4.NgClass, i4.NgIf, i4.NgForOf, i5.Table, i6.PrimeTemplate, i7.OverlayPanel, i8.ButtonDirective, i4.NgSwitch, i4.NgSwitchCase, i9.DefaultValueAccessor, i10.InputText, i9.NgControlStatus, i9.NgModel, i9.NumberValueAccessor, i11.Dropdown, i12.Calendar, i13.MatIcon, i14.MatMenuTrigger, i14.MatMenu, i14.MatMenuItem], styles: [".fd-master-table-header[_ngcontent-%COMP%]{display:block}.fd-master-table-header[_ngcontent-%COMP%]   .left-col[_ngcontent-%COMP%]{width:50%;float:left}.fd-master-table-header[_ngcontent-%COMP%]   .right-col[_ngcontent-%COMP%]{width:50%;float:right}.fd-title-container[_ngcontent-%COMP%]{margin-bottom:20px}.fd-title-container[_ngcontent-%COMP%], .left-box[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.left-box[_ngcontent-%COMP%]{margin-right:1rem;flex-direction:row;gap:10px}.right-box[_ngcontent-%COMP%]{margin-left:1rem}.right-box[_ngcontent-%COMP%]   .fd-form-box[_ngcontent-%COMP%]{display:flex;flex-direction:row-reverse;gap:10px}.right-box[_ngcontent-%COMP%]   .fd-single-form-box[_ngcontent-%COMP%]{border:1px dashed #d8dee6;background-color:#fff}.right-box[_ngcontent-%COMP%]   .h6-txt-pos[_ngcontent-%COMP%]{padding-left:.6rem}.right-box[_ngcontent-%COMP%]   .add-btn[_ngcontent-%COMP%]{margin-top:3rem}.master-table-head[_ngcontent-%COMP%]{padding-top:13px;font-weight:600;font-size:17px;padding-right:20px}.fb-rgt-br[_ngcontent-%COMP%]{border-right:1px solid #ddd}.fd-mar-btm[_ngcontent-%COMP%]{margin-bottom:20px}.fd-clear-btn[_ngcontent-%COMP%]{background-color:#6c757d;border-radius:3px;border:1px solid grey}.fd-apply-btn[_ngcontent-%COMP%], .fd-clear-btn[_ngcontent-%COMP%]{color:#fff;padding:5px 15px 5px 14px}.fd-apply-btn[_ngcontent-%COMP%]{background-color:#19a0da;border:#19a0da;border-radius:3px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FdMasterTableListCardComponent, [{
        type: Component,
        args: [{
                selector: 'lib-fd-master-table-list-card',
                templateUrl: 'fd-master-table-list-card.component.html',
                styleUrls: ['fd-master-table-list-card.component.scss']
            }]
    }], function () { return [{ type: FdMasterTableListCardService }, { type: i2.CustomButtonActionService }]; }, { inputParams: [{
            type: Input
        }], formBuilderInfo: [{
            type: Input
        }], overlayPanel: [{
            type: ViewChild,
            args: ['filterPanel']
        }], actionTriggered: [{
            type: Output
        }] }); })();

class FdMasterTableListCardModule {
}
FdMasterTableListCardModule.ɵfac = function FdMasterTableListCardModule_Factory(t) { return new (t || FdMasterTableListCardModule)(); };
FdMasterTableListCardModule.ɵmod = i0.ɵɵdefineNgModule({ type: FdMasterTableListCardModule });
FdMasterTableListCardModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            ReactiveFormsModule,
            PrimengLibraryModule,
            MatBadgeModule,
            MatMenuModule,
            MatIconModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FdMasterTableListCardModule, { declarations: [FdMasterTableListCardComponent], imports: [FormsModule,
        ReactiveFormsModule,
        PrimengLibraryModule,
        MatBadgeModule,
        MatMenuModule,
        MatIconModule], exports: [FdMasterTableListCardComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FdMasterTableListCardModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FdMasterTableListCardComponent
                ],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    PrimengLibraryModule,
                    MatBadgeModule,
                    MatMenuModule,
                    MatIconModule
                ],
                exports: [
                    FdMasterTableListCardComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of fd-master-table-list-card
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FdMasterTableListCardComponent, FdMasterTableListCardModule, FdMasterTableListCardService };
//# sourceMappingURL=fd-master-table-list-card.js.map
